import { State, initialState } from './property.state';
import { propertyActionTypes, Actions, LoadPropertiesAction } from './property.actions';
import { PropertyFilterSettings } from '../../shared/models/filter-settings';
import { getPropertySaveErrorMessage } from '../../../shared/utils/api-error.utils';

// eslint-disable-next-line @typescript-eslint/default-param-last
export function PropertyReducer(state = initialState, action: Actions): State {
  switch (action.type) {

    case propertyActionTypes.PROPERTY_CREATE_SUCCESS: {
      return Object.assign({}, state, {
        propertySaved: 'saved',
        selectedProperty: action.payload,
        selectedPropertyId: action.payload.propertyId
      });
    }

    case propertyActionTypes.LOAD_WorkspaceUserProperties_SUCCESS: {
      return Object.assign({}, state, { workspaceUserProperties: action.payload, hasProperties: action.payload.length > 0 });
    }

    case propertyActionTypes.LOAD_Selected_Property: {

      return Object.assign({}, state, {
        selectedFiscalYear: null,
      });
    }

    case propertyActionTypes.LOAD_Selected_Property_SUCCESS: {

      const loadPropertyResponse = action.payload;

      return Object.assign({}, state, {
        selectedProperty: loadPropertyResponse.property,
        selectedPropertyId: loadPropertyResponse.property.propertyId,
      });
    }

    case propertyActionTypes.LOAD_PROPERTIES: {

      const filter = (action as LoadPropertiesAction).payload?.filter;
      const propertyFilterSettings = new PropertyFilterSettings(filter?.filter, filter?.propertyTypeId);
      return {
        ...state,
        propertyFilterSettings: propertyFilterSettings,
        isLoading: false
      };
    }

    case propertyActionTypes.LOAD_PROPERTIES_SUCCESS: {

      const properties = action.payload;
      return {
        ...state,
        propertySearchResult: properties,
        isLoading: false
      };
    }

    case propertyActionTypes.CLEAR_PROPERTIES: {

      return {
        ...state,
        propertySearchResult: null,
        isLoading: false
      };
    }

    case propertyActionTypes.DELETE_Property_SUCCESS: {

      return {
        ...state,
        propertyFilterSettings: null,
        isLoading: false
      };
    }

    case propertyActionTypes.SET_SELECTED_FISCAL_YEAR: {
      return {
        ...state,
        selectedFiscalYear: action.payload,
        selectedYearPropertyFinancial: null
      };
    }

    case propertyActionTypes.UPDATE_FISCAL_YEARS: {

      const selectedProperty = Object.assign({}, state.selectedProperty);
      selectedProperty.fiscalYears = action.payload;

      return Object.assign({}, state, {
        selectedProperty: selectedProperty
      });
    }

    case propertyActionTypes.SAVE_PROPERTY_DETAILS: {
      return Object.assign({}, state, { savePropertyDetailsError: null });
    }

    case propertyActionTypes.SAVE_PROPERTY_DETAILS_SUCCESS: {
      const property = (action as any).payload?.property;
      return Object.assign({}, state, {
        propertySaved: 'saved',
        selectedProperty: property ?? state.selectedProperty,
        selectedPropertyId: property?.propertyId ?? state.selectedPropertyId,
        savePropertyDetailsError: null
      });
    }

    case propertyActionTypes.SAVE_PROPERTY_DETAILS_FAILS: {
      const message = getPropertySaveErrorMessage((action as any).payload);
      return Object.assign({}, state, { savePropertyDetailsError: message });
    }

    case propertyActionTypes.CLEAR_SAVE_PROPERTY_DETAILS_ERROR: {
      return Object.assign({}, state, { savePropertyDetailsError: null });
    }

    case propertyActionTypes.LOAD_PropertyTypes_SUCCESS: {
      return Object.assign({}, state, { propertyTypes: action.payload });
    }

    case propertyActionTypes.LOAD_EligibleNewPropertyWorkspaces_SUCCESS: {
      return Object.assign({}, state, { eligibleNewPropertyWorkspaces: action.payload });
    }

    case propertyActionTypes.LOAD_PropertyFinancial_SUCCESS: {
      return Object.assign({}, state, { selectedYearPropertyFinancial: action.payload });
    }

    case propertyActionTypes.LOAD_PropertyFinancial_FAILS: {
      return Object.assign({}, state, { selectedYearPropertyFinancial: null });
    }

    case propertyActionTypes.UPDATE_PropertyFinancial_SUCCESS: {
      return Object.assign({}, state, { selectedYearPropertyFinancial: action.payload });
    }

    case propertyActionTypes.CLEAR_PropertyFinancial_FROM_STATE: {
      return Object.assign({}, state, { selectedYearPropertyFinancial: null });
    }

    case propertyActionTypes.RECONCILE_FiscalYear: {
      return Object.assign({}, state, { reconcileFiscalYearSaved: 'inProgress' });
    }

    case propertyActionTypes.RECONCILE_FiscalYear_SUCCESS: {
      return Object.assign({}, state, { reconcileFiscalYearSaved: 'saved' });
    }

    case propertyActionTypes.RECONCILE_FiscalYear_FAILS: {
      return Object.assign({}, state, { reconcileFiscalYearSaved: 'failed' });
    }

    case propertyActionTypes.LOAD_SELECTED_PROPERTY_LAT_LONG_SUCCESS: {

      const selectedProperty = Object.assign({}, state.selectedProperty);
      selectedProperty.latLng = action.payload;

      return Object.assign({}, state, {
        selectedProperty: selectedProperty
      });
    }

    case propertyActionTypes.REMOVE_PROPERTY_PROFILE_IMAGE_SUCCESS: {

      const selectedProperty = Object.assign({}, state.selectedProperty);
      selectedProperty.profileImage = null;

      return Object.assign({}, state, {
        selectedProperty: selectedProperty
      });
    }

    case propertyActionTypes.GET_ALL_PROPERTY_RESERVE_STUDY_SUCCESS: {

      const studies = action.payload;
      return {
        ...state,
        reserveStudies: studies
      };
    }

    case propertyActionTypes.ADD_PROPERTY_RESERVE_STUDY_SUCCESS: {

      const study = action.payload;
      let studies = Object.assign([], state.reserveStudies);
      studies.push(study);
      studies = studies.sort((a, b) => {return a.date < b.date ? 1 : -1; } );  //sort desc by date

      return {
        ...state,
        reserveStudies: studies
      };
    }

    case propertyActionTypes.UPDATE_PROPERTY_RESERVE_STUDY_SUCCESS: {

      const study = action.payload;
            
      let studies = Object.assign([], state.reserveStudies);
            
      const index = studies.findIndex(x => x.propertyReserveStudyId === study.propertyReserveStudyId);
      if (index >= 0) {
        studies.splice(index, 1, study);
        studies = studies.sort((a, b) => {return a.date < b.date ? 1 : -1; } );  //sort desc by date
      }

      return {
        ...state,
        reserveStudies: studies
      };
    }

    case propertyActionTypes.DELETE_PROPERTY_RESERVE_STUDY_SUCCESS: {

      const studyId = action.payload;
            
      const studies = Object.assign([], state.reserveStudies);
            
      const index = studies.findIndex(x => x.propertyReserveStudyId === studyId);
      if (index >= 0) {
        studies.splice(index, 1);
      }

      return {
        ...state,
        reserveStudies: studies
      };
    }

    /*
        case Auth.LOGOUT: {
            return Object.assign({}, initialState);
        }
        */
    default: {
      return state;
    }
  }
}
